export const IS_LOADING = "IS_LOADING";
export const SERVICOM = "SERVICOM";
export const SERVICOM_CONTACT = "SERVICOM_CONTACT";
